var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.708 27.25H22.208V26.25H12.708ZM12.708 20.5H27.292V19.5H12.708ZM12.708 13.75H27.292V12.75H12.708ZM9.5 32.833Q8.5 32.833 7.833 32.167Q7.167 31.5 7.167 30.5V9.5Q7.167 8.5 7.833 7.833Q8.5 7.167 9.5 7.167H30.5Q31.5 7.167 32.167 7.833Q32.833 8.5 32.833 9.5V30.5Q32.833 31.5 32.167 32.167Q31.5 32.833 30.5 32.833ZM9.5 31.833H30.5Q31 31.833 31.417 31.417Q31.833 31 31.833 30.5V9.5Q31.833 9 31.417 8.583Q31 8.167 30.5 8.167H9.5Q9 8.167 8.583 8.583Q8.167 9 8.167 9.5V30.5Q8.167 31 8.583 31.417Q9 31.833 9.5 31.833ZM8.167 31.833Q8.167 31.833 8.167 31.417Q8.167 31 8.167 30.5V9.5Q8.167 9 8.167 8.583Q8.167 8.167 8.167 8.167Q8.167 8.167 8.167 8.583Q8.167 9 8.167 9.5V30.5Q8.167 31 8.167 31.417Q8.167 31.833 8.167 31.833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.d7d179c94e346af3282cef58778ff718.svg";
export { ForwardRef as ReactComponent };